export const BLACK    = '#000000';
export const GRAY     = '#7b7b8b';
export const WHITE    = '#ffffff';
export const PURPLE   = '#330066';
export const LIGTH_GRAY = '#ECEBEF';
export const TRANSPARENT = 'transparent';